"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var jquery_1 = __importDefault(require("jquery"));
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            var totalLastItem = (0, jquery_1.default)('.lastTenItem .coCategoryItemCard-Container').length;
            if (totalLastItem === 0) {
                (0, jquery_1.default)(_this.expandBtnTarget).hide();
            }
        };
        _this.open = function () {
            (0, jquery_1.default)(_this.lastTenItemWrapperTarget).removeClass('d-none');
            (0, jquery_1.default)(_this.collapseBtnTarget).removeClass('d-none');
            (0, jquery_1.default)(_this.expandBtnTarget).addClass('d-none');
            (0, jquery_1.default)(_this.fullPageInfoTarget).show();
            (0, jquery_1.default)(_this.firstPageInfoTarget).hide();
        };
        _this.close = function () {
            (0, jquery_1.default)(_this.lastTenItemWrapperTarget).addClass('d-none');
            (0, jquery_1.default)(_this.collapseBtnTarget).addClass('d-none');
            (0, jquery_1.default)(_this.expandBtnTarget).removeClass('d-none');
            (0, jquery_1.default)(_this.fullPageInfoTarget).hide();
            (0, jquery_1.default)(_this.firstPageInfoTarget).show();
        };
        return _this;
    }
    default_1.targets = ['lastTenItemWrapper', 'expandBtn', 'collapseBtn', 'firstPageInfo', 'fullPageInfo'];
    return default_1;
}(stimulus_1.Controller));
exports.default = default_1;
